module.exports = __webpack_public_path__ + "img/account.47a2f6f3.svg";